import { Dropdown } from "react-bootstrap";
import CustomInput from '../../atoms/Input';
import { useEffect, useState } from "react";
import searchIcon from '../../../assets/icons-search.png';
import useDebounce from "./useDebounce";
import CustomSpinner from '../../../components/atoms/CustomSpinner';

function CustomDropdown({ className, data, defaultValue, value, onSelect }) {
    
    const [search, setSearch] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const debouncedValue = useDebounce(search, 500);
    // const debouncedLoading = useDebounce(isLoading, 2500);

    const handleChange = (e) => {
        setSearch(e.target.value);
    }

    return (
        <Dropdown onSelect={onSelect}>
            <Dropdown.Toggle variant='primary' id='dropdown-basic' className={className ? className : ""}>
                {value || defaultValue}
            </Dropdown.Toggle>
            <Dropdown.Menu  className="filter-dropdown-menu">
                <CustomInput
                    value={search}
                    onChange={handleChange}
                    customIconObject={{
                        showCustomIcon: true,
                        name: 'search',
                        source: searchIcon
                    }}/>
                    {/* { isLoading ? <CustomSpinner /> : 'Veri bulunamadı' } */}
                {
                    data?.filter(item => {
                        if (search === null) {
                            //if search is empty
                            return item;
                        } else if (item.toLocaleLowerCase('tr').includes(debouncedValue?.toLocaleLowerCase('tr'))) {
                            //returns filtered array
                            return item;
                        }
                    }).map((item, index) => {
                        return (
                            <Dropdown.Item
                                className={'filter-dropdown-item'}
                                key={index}
                                eventKey={item}
                            >
                                {item}
                            </Dropdown.Item>
                        )
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    );
}
export default CustomDropdown; 